//Material UI
import "./payrollSettings.css";
import "../../companyDetails.css";
import T from "utils/constants/T";
import MainCard from "components/MainCard";
import { Button, Stack } from "@mui/material";

interface ViewPayrollSettingsBtnProps {
  systemName: string;
  role: string;
  handleSyncDeputy: () => void;
  handleSyncDeputyPayroll: () => void;
}
const ViewPayrollSettingsBtn = ({
    systemName = "",
    role = "",
    handleSyncDeputy,
    handleSyncDeputyPayroll,
}: ViewPayrollSettingsBtnProps) => {
    const hasAccess = role === "superadmin" || role === "employer";
    return (
        <MainCard
            title={systemName}
            secondary={
                hasAccess && (
                    <Stack direction="row" spacing={1.5} alignItems="center">
                        <Button
                            variant="outlined"
                            className="main-card-button"
                            onClick={handleSyncDeputyPayroll}
                        >
                            {T.SYNC_PAYROLL}
                        </Button>
                        <Button
                            variant="contained"
                            className="main-card-button"
                            onClick={handleSyncDeputy}
                        >
                            {T.reAuth}
                        </Button>
                    </Stack>
                )
            }
        />
    );
};

export default ViewPayrollSettingsBtn;
